module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-main"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_vm._v(_vm._s(_vm.team.name))]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Settings")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Rename")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-section"
  }, [_c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('name')
    }
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.team.name),
      expression: "team.name"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "Name"
    },
    domProps: {
      "value": _vm._s(_vm.team.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.team.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('namespace')
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Namespace")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.team.namespace),
      expression: "team.namespace"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "id": "namespace",
      "placeholder": "Name space",
      "disabled": ""
    },
    domProps: {
      "value": _vm._s(_vm.team.namespace)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.team.namespace = $event.target.value
      }
    }
  })])], 1)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    class: {
      'btn-default': _vm.isSubmiting
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmiting
    }
  }, [(_vm.isSubmiting) ? _c('div', {
    staticClass: "loader vertical-align-middle loader-circle loader-form"
  }) : _vm._e(), _vm._v(" Submit\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header-actions"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "icon md-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text hidden-sm-down"
  }, [_vm._v(" Add User")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42d46286!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teams/TeamDeactivate.vue
// module id = 527
// module chunks = 1